export const ADD_ON_ORDERS_LIMIT = 15;
export const ALL_DAYS = 'all_days';
export const PAST_7_DAYS = 'past_7_days';
export const PAST_30_DAYS = 'past_30_days';
export const ALL_STATUSES = 'all_statuses';
export const REDEEMED = 'redeemed';
export const NOT_REDEEMED = 'not_redeemed';
export const SMALL_DEVICE_BREAK_POINT = 928;
export const CANCELLED = 'CANCELLED';
export const ADD_ON_LISTING_STATES = ['DRAFT', 'POSTED', 'EXPIRED', 'ARCHIVED'];
export const HOSTED_LISTING_LIMIT = 300;
export const ADD_ONS_LIMIT = 15;
